import { CREATE_ACCOUNT_REQUEST, CREATE_ACCOUNT_SUCCESS, CREATE_ACCOUNT_FAILURE } from '../../constants/account.constants';

export const createAccountRequest = (login, password, first_name, last_name) => ({
    type: CREATE_ACCOUNT_REQUEST, login, password, first_name, last_name,
});

export const createAccountRequestSuccess = () => ({
    type: CREATE_ACCOUNT_SUCCESS,
});

export const createAccountRequestFailure = error => ({
    type: CREATE_ACCOUNT_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/App/redux/actions/account_actions/create_account.actions.js